import { ActivityParticipatedPlayer } from "./activity"

export enum MainFooted {
  Left = "L",
  Right = "R",
  All = "A",
}

type PlayerType = {
  idfPlayer?: number
  email: string
  country: string
  password: string
  name: string
  nickname: string
  birthday: string
  gender: string
  height: number
  weight: number
  foot: MainFooted
  position: string
  authCode: string
  image?: string | null
  uniformNumber?: number
  idfPlayerGroup?: number
  deviceSerial?: string
  numberUniform?: number
  idfActivity?: number
  playTime?: number
  backNumber?: number
  positionGroup?: string
  participatedSessions?: number[]
}

type PlayerKey = keyof PlayerType

type Player = { [key in PlayerKey]: PlayerType[key] }

type CreatePlayerPayload = {
  idfTeam: number
  email: string
  country: string
  password: string
  name: string
  nickname: string
  birthday: string
  gender: string
  height: number
  weight: number
  foot: MainFooted
  position: string
  authCode: string
}

type JoinPlayerPayload = {
  authCode: string
}

type UpsertPlayerPayload = {
  position: string
  height: number
  weight: number
  foot: string
  hand: string
  nickname: string
  birthday: string
  uniformNumber: number
  model: string
  version: string
  number: number
}
type ReadAssignablePlayersResponse = Player[]

type ReadPlayerInfoParams = {
  idfPlayer?: number
  idfActivity?: number
  idfTeam?: number
}

type TeamPlayer = {
  idfPlayer: number
  nickname: string
  position: string
  image: string
  gender: string
  email: string
  birthday: string
  height: number
  weight: number
  foot: MainFooted
  hand: MainFooted
  uniformNumber: number
  deviceSerial: string
}

type PlayerSummary = {
  idfPlayer: number
  playerName: string
  playerNumber: number
  rpe: number
}
type ReadPlayerInfoResponse = TeamPlayer

type UpsertPlayerGroupPayload = {
  idfPlayerGroup: number | null
}

type UpsertMovePlayerPayload = {
  destIdfTeam: number
  srcIdfTeam: number
  players: number[]
}

type ReadParticipateActivityParams = { idfPlayer: number; start?: number; end?: number }

type ParticipatedPlayer = {
  idfActivity: number
  name: string
  type: string
  dateStart: string
  dateFinish: string
  playerCount: number
}
type ReadParticipatedPlayersResponse = ParticipatedPlayer[]
type ReadParticipateActivityResponse = ParticipatedPlayer[]

type PlayerDataType = Pick<ActivityParticipatedPlayer, "idfPlayer" | "position"> & {
  idfActivity: number
  idfTeam: number
  playerName: string
  playerNumber: number
  ifData: number
  rpe?: number
  idfTeamPlayerGroup: number
  // activity detail api 에서 사용
  idfPlayerGroup?: number
  activityTime?: number
  image: string | null
}

type PlayerDataKey = keyof PlayerDataType

type PlayerData = { [key in PlayerDataKey]: PlayerDataType[key] }

export type {
  Player,
  PlayerKey,
  PlayerSummary,
  PlayerType,
  ReadPlayerInfoParams,
  CreatePlayerPayload,
  JoinPlayerPayload,
  UpsertPlayerPayload,
  ReadAssignablePlayersResponse,
  ReadPlayerInfoResponse,
  UpsertPlayerGroupPayload,
  UpsertMovePlayerPayload,
  ReadParticipateActivityParams,
  ReadParticipatedPlayersResponse,
  ReadParticipateActivityResponse,
  TeamPlayer,
  ParticipatedPlayer,
  PlayerData,
}
